<template>
    <div class="c-loader" aria-live="polite">
        <div class="c-loader__spin">
            <i class="fa-regular fa-circle-notch fa-spin" aria-hidden="true"></i>
            <span class="c-loader__label">Loading...</span>
        </div>
    </div>
</template>

<script>

export default {
    name: "Loader",
}
</script>

<style scoped>

</style>
